"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberCleaner = void 0;
const numberCleaner = (value) => {
    const roundedThreshold = 100;
    return Math.round(value * roundedThreshold) / roundedThreshold;
};
exports.numberCleaner = numberCleaner;
//# sourceMappingURL=numberCleaner.js.map